export default __webpack_public_path__ + "static/media/datamodel.5a524200.png";